import { cn } from '@bazaar-marketplace/utils';

function Skeleton({ className, ...props }: React.ComponentProps<'div'>) {
  return <div className={cn('bg-white/10 animate-pulse rounded-md', className)} data-slot="skeleton" {...props} />;
}

export { Skeleton };
